/*
 * @Author: Jackson
 * @Email: zhangjiajun@everimaging.com
 * @Date: 2021-01-12 17:17:36
 * @Description:
 *
 */

import './App.scss';
import 'src/assets/font/index.scss';

import { FTCanvasStore, FTImageStore, FTUserStore } from 'src/store';
import { FTLang, utils } from 'src/utils';

import { Layout } from 'src/components';
import React from 'react';
import { actionEnter } from 'src/analyze/actions';
import { message } from 'antd';

// import mousetrap from 'mousetrap';

class Root extends React.Component<{}, {}> {
  state = {
    loadLanguage: false,
  };
  componentDidMount() {
    this.loadLanguage();
    FTCanvasStore.init();
    FTUserStore.getShowCountryAd();
    this.loadLoginSdk();
    this.loadPaymentSdk();
    this.stopDragDefaultEvent();
    this.addKeyBoardEvent();
  }

  addKeyBoardEvent = () => {
    // let Mousetrap = new mousetrap(document.body);
    // Mousetrap.bind('left', () => {
      // FTImageStore.prev()
    // });
    // Mousetrap.bind('right', () => {
      // FTImageStore.next()
    // });
  };

  stopDragDefaultEvent = () => {
    document.body.addEventListener('drop', (e) => {
      e.stopPropagation();
      e.preventDefault();
    });
    document.body.addEventListener('dragover', (e) => {
      e.stopPropagation();
      e.preventDefault();
    });

    // 阻止双击放大
    var lastTouchEnd = 0;
    document.addEventListener('touchstart', function (event) {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    });
    document.addEventListener(
      'touchend',
      function (event) {
        var now = new Date().getTime();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      },
      false,
    );
    // 阻止双指放大
    document.addEventListener('gesturestart', function (event) {
      event.preventDefault();
    });
  };

  loadLoginSdk = () => {
    utils.loadLoginScript().then(() => {
      FTUserStore.checkUserLogin();
      // 注册google一键登陆的回调
      window['login'] &&
        window['login'].loginSuccess((res: any) => {
          FTUserStore.checkUserLogin();
          FTUserStore.getUserActivity();
          FTUserStore.getShowCountryAd();
        });
    });
  };

  loadLanguage = async () => {
    await FTLang.updateLanguage();
    this.setState({
      loadLanguage: true,
    });
  };
  loadPaymentSdk = () => {
    utils.loadPaymentSdk();
  };
  render() {
    return (
      <React.Fragment>
        <Layout />
      </React.Fragment>
    );
  }
}

function App() {
  function offline() {
    message.error(FTLang._('notification_network_offline'));
  }
  React.useEffect(() => {
    utils.loadMobileCommonScript();

    // 移动端，显示进入弹窗
    // utils.myBrowserOS().isMobile && utils.mobileCommonSdkLoaded(() =>{
    //   const inst = window.mobileCommon.EntryPopupInstance();
    //   inst.show({
    //     bannerImg: link_to_app_image,
    //     langMap: {
    //         title: FTLang._('mobile_enter_pop_title'),
    //         desc: FTLang._('mobile_enter_pop_desc'),
    //         btn_open_app: "Get to App",
    //         btn_cancel: "Cancel",
    //     },
    //     openAppHandle() {
    //       window.mobileCommon.openFotorAppByAdjustLink({
    //         adgroup: "inner-button",
    //         campaign: "goart.fotor.com/",
    //         schema: "fotor://funtionExperience/home?type=ai_art_effects&channel=web",
    //       });
    //       inst.hide();
    //     }
    //   });
    // });
    actionEnter({
      category_name: FTImageStore.currentClassify,
      category_id:FTImageStore.initClassifyId,
      resource_name:"",
      resource_id:FTImageStore.initEffectId
    });
    window.addEventListener('offline', offline);
    return () => {
      window.removeEventListener('offline', offline);
    };
  }, []);
  return <Root />;
}

export default App;
